import { Icon } from "@chakra-ui/react";
import { FaXTwitter } from "react-icons/fa6";

import { NavButton, NavButtonProps } from "./nav-button";

import { PLUME_X_URL } from "@/constants/shared";

export const XButton = (props: Omit<NavButtonProps, "href">) => (
  <NavButton
    variant="ghost"
    href={PLUME_X_URL}
    target="_blank"
    p={0}
    {...props}
  >
    <Icon boxSize={6} color="fg.muted">
      <FaXTwitter />
    </Icon>
  </NavButton>
);
